import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Select from "react-select";
import CardLayout from "../../../common/cardLayout/CardLayout";
import { useSelector, useDispatch } from "react-redux";
import {
  getPatientPhysicians,
  setPatientPhysician,
} from "../../../../store/features/patient/patientSlice";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/CloseIcon.svg";
const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "50%",
  },
};

const AssignPhysicianModal = ({ modalIsOpen, setIsOpen, patientId }) => {
  Modal.setAppElement("#root");
  const dispatch = useDispatch();
  const { user, selectedClinic } = useSelector((state) => state.app);
  const {
    patientNotesLoading,
    flagLoading,
    patientPhysicians,
    singlePatientData,
  } = useSelector((state) => state.patient);

  function closeModal() {
    setIsOpen(false);
  }

  const [physicianOptions, setPhysicianOptions] = useState([]);

  useEffect(() => {
    const clinic_id = selectedClinic?.clinic?.id;
    const params = { clinic_id: clinic_id };

    dispatch(getPatientPhysicians(params));
    var data = [{ label: "RESET To None", value: { name: "None", id: "" } }];
    patientPhysicians.forEach((item) => {
      data.push({ label: item["name"], value: item });
    });
    setPhysicianOptions(data);
    setPhysician(data[0]);
  }, []);

  const [selectedPhyscian, setPhysician] = useState([]);
  const [patientPhysician, resetPhysician] = useState(
    singlePatientData?.physician
  );
  const [commentText, setCommentText] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    let payload = {
      name: selectedPhyscian.value?.name,
      id: selectedPhyscian.value?.id,
      patient_id: patientId,
    };
    dispatch(setPatientPhysician(payload));
    resetPhysician(selectedPhyscian.value?.name);
    setCommentText("");
    closeModal();
  };

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel=""
    >
      <div className="container-fluid">
        <button
          style={{
            position: "absolute",
            right: "15px",
            border: "0px",
            fontFamily: "DM Sans",
            backgroundColor: "transparent",
          }}
          onClick={closeModal}
        >
          <CloseIcon />
        </button>
        <CardLayout className="p-3">
          <div className="w-100 pt-2 d-flex justify-content-start">
            <h3 className="primary-text-blue">Assign Physician</h3>
          </div>
          <form className="container-fluid w-100" onSubmit={handleSubmit}>
            <div className="form-group pb-3 w-100">
              <label>Choose Physician *</label>
              <Select
                menuPortalTarget={document.body}
                menuPosition={"fixed"}
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    border: "0px",
                    borderBottom: "1px solid #94A3B8",
                    borderRadius: "0px",
                    padding: "5px",
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                placeholder="Select Physician"
                classNamePrefix="select"
                name="flag"
                options={physicianOptions}
                value={selectedPhyscian}
                isDisabled={flagLoading || patientNotesLoading}
                onChange={(e) => {
                  setPhysician(e);
                }}
              />
            </div>

            <div
              style={{ gap: "5%" }}
              className="d-flex justify-content-end py-3 container-fluid w-100"
            >
              <button className="btn alternative-btn" onClick={closeModal}>
                Cancel
              </button>
              <button
                className="primary-btn"
                type="submit"
                disabled={flagLoading || patientNotesLoading}
              >
                Confirm
              </button>
            </div>
          </form>
        </CardLayout>
      </div>
    </Modal>
  );
};

export default AssignPhysicianModal;
